const colors = {
    '_0': '#ff0000',
    '_1': '#ff0000',
    '_2': '#ffb300',
    '_3': '#ffb300',
    '_4': '#88ff00',
    '_5': '#46ab46'
}

export default colors
